import axios from 'src/utils/axios';

export const fetchSupportAvailability = botId =>
  axios.get(`/api/support/${botId}/availability`);

export const fetchMySupportAvailability = botId =>
  axios.get(`/api/support/${botId}/availability/me`);

export const createSupportAvailabilityStreamTicket = botId =>
  axios.post(`/api/support/${botId}/availability/stream-ticket`);

export const updateSupportAvailability = (botId, status) =>
  axios.post(`/api/support/${botId}/availability`, { status });

export const checkSupportAvailabilityEntry = botId =>
  axios.post(`/api/support/${botId}/availability/entry`);
